import { LABEL_WEIGHT } from "../../../../components/label/constants";

export default {
    instructionCard: {
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '20px',
        margin: '1px 0',
        maxHeight: '850px',
        overflowY: 'scroll',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
        fontFamily: 'Arial, sans-serif',
        fontSize: '18px',
        lineHeight: '2.5',
    },
    title: {
        fontSize: '22px',
        fontWeight: 'bold',
        marginBottom: '16px',
        color: '#333',
    },
    instructions: {
        listStyleType: 'none',
        padding: '0',
        margin: '0',
    },
    listItem: {
        marginBottom: '12px',
    },
    sublist: {
        listStyleType: 'circle',
        paddingLeft: '20px',
        marginBottom: '12px',
    },
    sublistItem: {
        marginBottom: '8px',
    },
    headings: {
        fontSize: '24px',
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: '30px',
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: '40px 20px',
        fontFamily: 'Arial, sans-serif',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
    },
    leftSide: {
        flex: '1', // Equal flex basis for both sides
        marginRight: '20px',
        overflow: 'auto', // Allow content to scroll if it overflows
    },
    rightSide: {
        flex: '1', // Equal flex basis for both sides
        overflow: 'auto', // Allow content to scroll if it overflows
    },
    // leftSide: {
    //     flex: 3,
    //     marginRight: '20px',
    // },
    // rightSide: {
    //     flex: 3,
    // },
    cardContent: {
        padding: '20px',
    },
    sectionHeader: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '20px',
        color: '#333',
    },
    label: {
        fontWeight: LABEL_WEIGHT[700],
        marginRight: '10px',
    },
    filterRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px',
        gap: '10px',
    },
    buttonRow: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '20px',
        gap: '10px',
    },
    label: {
        fontWeight: 'bold',
        marginRight: '5px'
    },
    value: {
        marginLeft: '10px'
    },
    pairsContainer: {
        marginTop: '20px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '10px',
        backgroundColor: '#f9f9f9',
    },
    pairsList: {
        listStyleType: 'none',
        padding: 0,
        margin: 0,
    },
    pairItem: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px',
        borderBottom: '1px solid #ddd',
    },
    pairKey: {
        fontWeight: 'bold',
    },
    pairValue: {
        marginLeft: '10px',
    },
    pairsContainer: {
        marginTop: '20px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '10px',
        backgroundColor: '#f9f9f9',
    },
    pairsList: {
        listStyleType: 'none',
        padding: 0,
        margin: 0,
    },
    pairItem: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px',
        borderBottom: '1px solid #ddd',
        marginBottom: '4px',
        borderRadius: '4px',
        backgroundColor: '#e0e0e0',
    },
    pairButton: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '4px 8px',
        borderRadius: '4px',
        backgroundColor: '#2196f3',
        color: 'white',
    },
    removeButton: {
        marginLeft: '8px',
        cursor: 'pointer',
        fontWeight: 'bold',
    },
    selectPayerContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px'
    },
    filtersContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px'
    },
    checkboxMargin: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '10px'
    },
    flex: {
        flex: 1

    },

    dropdownMarginLeft: {
        marginLeft: '20px'
    },
    marginTop: {
        marginTop: '10px'
    },
    marginBottom: {
        marginBottom: '20px'
    },
    filtersContainer: {
        flexDirection: 'row',
        marginLeft: '10px'
    },
    filtersDropdown: {
        flex: 1,
        marginBottom: '20px',
        marginRight: '10px'
    },
    selectedFiltersCard: {
        marginBottom: '30px'
    },
    filterContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '20px'
    },
    filterDetails: {
        border: '1px solid black',
        display: 'flex',
        alignItems: 'center',
        padding: '5px',
        borderRadius: '15px'
    },
    removeFilterButton: {
        marginLeft: '10px',
        padding: '0',
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        color: 'red'
    },
    spanLabel: {
        margin: '0 10px',
        color: '#777'
    },
    popupDropdownContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px',
        marginLeft: '20px'
    },
    popupStyle: {
        maxWidth: '1000px',
        minHeight: '300px'
    },
    popupHeaderStyle: {
        backgroundColor: 'lightblue'
    },
    popupDropdownWidth: {
        width: '200px'
    },
    popupBtnContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '15px'
    },
    popupCancelBtn: {
        backgroundColor: 'red',
        color: 'white'
    }

}
